import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { getToken } from "../helpers/Jwt";
import { confirmDelete } from "../helpers/PromptUtils";
import { appVersion } from './version';


const Sidebar = ({ user, toggleSidebar, onToggleClick }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useAuth();
    // const [open, setOpen] = useState(true); // Sidebar initially open
    const [menus, setMenus] = useState([]);
    const [activeMenu, setActiveMenu] = useState(null);
    const [loading, setLoading] = useState(false);

    const [appName, setAppName] = useState("Hijrah SuperApp");
    const [appLogo, setAppLogo] = useState(`/assets/icon_network.png`);

    const fetchProject = async (id_project) => {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}api/core/project/project/detail?id=${id_project}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getToken()}`
            }
        });

        setAppName(response.data.name);
        setAppLogo(`${process.env.REACT_APP_API_URL}upload/logo/${response.data.logo}`)
    };

    useEffect(() => {
        setLoading(true);
        if (user != null) {
            if (user.user.id_project !== 0) {
                fetchProject(user.user.id_project);
            }
            axios({
                method: 'GET',
                url: `${process.env.REACT_APP_API_URL}api/system/menu`,
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                }
            }).then(function (response) {
                setMenus(response.data.data);
                setLoading(false);
            });
        }
    }, [user]);

    const handleMenuClick = (index) => {
        setActiveMenu(null);
        if (menus[index].submenus.length === 0) {
            navigate(menus[index].endpoint);
        } else {
            setActiveMenu(activeMenu === index ? null : index);
        }
    };

    const handleLogout = () => {
        const confirmed = confirmDelete('Are you sure you want to leave this apps?');
        if (confirmed) {
            logout();
        }
    };

    return (
        <div className="flex">
            {loading && <p>Loading...</p>}

            {!loading &&

                <div style={{
                    height: '100%', minHeight: '100vh'
                }} className={` ${toggleSidebar ? "w-72" : "w-20"} ${user?.user?.role_user === 'superadmin' ? 'bg-[#973131]' : 'bg-[#198754]'} h-screen p-5 pt-8 relative duration-300`}>
                    <img
                        src={`/assets/burger-menu.svg`}
                        className={`bg-white absolute cursor-pointer -right-3 top-9 w-7 border-dark-purple border-2 rounded-full ${!toggleSidebar && "rotate-180"}`}
                        onClick={onToggleClick}
                    />

                    <div className="gap-x-4 items-center">
                        <div className="flex items-center">
                            <img
                                src={appLogo}
                                alt="Logo"
                                className="w-10 h-auto mr-3"
                            />
                            <h1 className={`text-white origin-left font-medium text-xl duration-200 ${!toggleSidebar ? "scale-0" : "scale-100"}`}>
                                {appName}
                            </h1>
                        </div>
                        <p className={`text-white duration-200 ${!toggleSidebar && "scale-0"}`}>
                            Masuk Sebagai, {user?.user?.name}
                        </p>
                    </div>

                    <ul className="pt-6">
                        {menus.map((menu, index) => (
                            <div key={index}>

                                {(menu.submenus.length === 0) ?
                                    <a href={menu.endpoint}
                                        className={`flex rounded-md p-2 cursor-pointer hover:bg-[#C6A969] text-gray-300 text-sm items-center gap-x-4 ${menu.gap ? "mt-9" : "mt-2"} ${activeMenu === index || (menu.endpoint && location.pathname === menu.endpoint) ? "bg-[#C6A969]" : ""}`}
                                        style={{
                                            textDecoration: 'none'
                                        }}>
                                        <img
                                            src={`${process.env.REACT_APP_API_BASE_URL}${menu.icon}`}
                                            alt="Menu Icon"
                                            className="w-10 h-auto mr-3"
                                        />
                                        <span className={`duration-200 text-white ${!toggleSidebar && "hidden"}`}>
                                            {menu.name}
                                        </span>
                                    </a>
                                    :
                                    <div
                                        className={`flex rounded-md p-2 cursor-pointer hover:bg-[#C6A969] text-gray-300 text-sm items-center gap-x-4 ${menu.gap ? "mt-9" : "mt-2"} ${activeMenu === index || (menu.endpoint && location.pathname === menu.endpoint) ? "bg-[#C6A969]" : ""}`}
                                        onClick={() => handleMenuClick(index)}>
                                        <img
                                            src={`${process.env.REACT_APP_API_BASE_URL}${menu.icon}`}
                                            alt="Menu Icon"
                                            className="w-10 h-auto mr-3"
                                        />
                                        <span className={`${!toggleSidebar && "hidden"} origin-left duration-200 text-white`}>
                                            {menu.name}
                                        </span>
                                    </div>
                                }
                                {activeMenu === index && menu.submenus && (
                                    <ul className="pl-5">
                                        {menu.submenus.map((submenu, subIndex) => (
                                            <Link
                                                to={submenu.endpoint}
                                                key={subIndex}
                                                className={`flex rounded-md p-2 cursor-pointer hover:bg-[#C6A969] text-gray-300 text-sm items-center gap-x-4 mt-2 ${location.pathname === submenu.endpoint ? "bg-[#C6A969]" : ""}`}
                                            >
                                                <span className={`${!toggleSidebar && "hidden"} origin-left duration-200 text-white`}>
                                                    {submenu.name}
                                                </span>
                                            </Link>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}

                        <div
                            className={`flex rounded-md py-3 px-2 cursor-pointer hover:bg-[#C6A969] text-gray-300 text-sm items-center gap-x-4`}
                            onClick={handleLogout}
                        >
                            <img
                                src={`/assets/logout.png`}
                                alt="Logout Icon"
                                className="w-10 h-auto mr-3"
                            />
                            <span className={`origin-left duration-200 text-white`}>
                                Logout
                            </span>
                        </div>
                        <div  className="text-white mt-3">
                            <p className="text-xs">
                                Version Number <b>{appVersion}</b>
                            </p>
                        </div>
                    </ul>
                </div>
            }
        </div>
    );
};

export default Sidebar;